import Link from '@/components/Link';
import PageBlock from '@/components/PageBlock';
import { Button, ButtonsContainer, ThemeContext } from '@forma/forma-ui-kit';
import Image from 'next/image';
import { useContext } from 'react';

import styles from './send-sign-banner.module.css';

const SendSignBanner = () => {
  const { viewport } = useContext(ThemeContext);
  const showMobileImage = ['phone', 'tabletS', 'tablet', 'desktopS'].includes(viewport);

  return (
    <PageBlock className={styles.root} contentClassName={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>Отправка документов на подпись</div>
        <div className={styles.description}>
          Подписывайте договоры, акты и пакеты документов с физлицами, подрядчиками, внештатными сотрудниками,
          частными клиентами онлайн простой электронной подписью ПЭП через SMS. Полное соответствие 152-ФЗ.
        </div>
        <ButtonsContainer className={styles.buttons}>
          <Button
            as={Link}
            href="/sign"
            className={styles.button}
          >
            Подписать 1-й документ
          </Button>
        </ButtonsContainer>
      </div>
      {showMobileImage ? (
        <Image className={styles.image} src="/images/banner-sign-mobile.webp" alt="" width={328} height={171} />
      ) : (
        <Image className={styles.image} src="/images/banner-sign.webp" alt="" width={565} height={294} />
      )}
    </PageBlock>
  );
};

export default SendSignBanner;
